module.exports = __webpack_public_path__ + "img/crop3.f2707595.png";